import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export interface Spot {
    name: string;
    unique_identifier: string | null;
    description: string | null;
    street: string | null;
    number: string | null;
    bus: string | null;
    city: string | null;
    zip_code: string | null;
    province: string | null;
    region: string | null;
    country: string | null;
    longitude: number | null;
    latitude: number | null;
    status: SpotStatus;
    network: SpotNetworkType;
    network_identifier: string | null;
    type: SpotType | null;
    id: string;
    account_id: string;
    update_timestamp: string;
    creation_timestamp: string;
    delete_timestamp: string | null;
}

export type SpotsQueryParams = DefaultQueryParams | QueryParams;

enum QueryParams {
    ACCOUNT_ID = 'account_id',
    STATUS = 'status',
    LATITUDE = 'latitude',
    LONGITUDE = 'longitude'
}

export type SpotListResponse = PaginatedResponse<Spot>;

export interface CreateSpot {
    name?: string;
    description?: string | null;
    unique_identifier?: string | null;
    street?: string | null;
    number?: string | null;
    bus?: string | null;
    city?: string | null;
    zip_code?: string | null;
    province?: string | null;
    region?: string | null;
    country?: string | null;
    longitude?: number | null;
    latitude?: number | null;
    status?: SpotStatus;
    network?: SpotNetworkType;
    network_identifier?: string | null;
    type?: SpotType | null;
}

export interface UpdateSpot {
    name?: string | null;
    description?: string | null;
    unique_identifier?: string | null;
    street?: string | null;
    number?: string | null;
    bus?: string | null;
    city?: string | null;
    zip_code?: string | null;
    province?: string | null;
    region?: string | null;
    country?: string | null;
    null_fields?: string[];
    delete_timestamp?: string | null;
    longitude?: number | null;
    latitude?: number | null;
    status?: SpotStatus | null;
    network?: SpotNetworkType;
    network_identifier?: string | null;
    type?: SpotType | null;
}

export enum SpotNetworkType {
    BPOST = 'bpost',
    S4M = 's4m',
    TELLOPORT = 'telloport'
}

export enum SpotStatus {
    AVAILABLE = 'available',
    DISABLED = 'disabled'
}

export enum SpotType {
    DISTRIBUTION_CENTER = 'distribution_center',
    RECEIVING_POINT = 'receiving_point',
    SITE_HUB = 'site_hub'
}
